module.exports = __webpack_public_path__ + "static/media/trivvyTextLogo.12cc4136.png";